import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { ChartData, TCarbonUnit } from "@/types";

import CategoryDetailPopover from "./CategoryDetailPopover";
import ConsolidationPie from "./ConsolidationPie";

type CategoryChartProps = {
  title: string;
  carbon: number;
  carbonToDisplay: string;
  carbonUnit: TCarbonUnit;
  data: ChartData;
};

function CategoryChart({
  title,
  data,
  carbon,
  carbonToDisplay,
  carbonUnit,
}: CategoryChartProps) {
  const { t } = useTranslation("common");

  return (
    <div className="border-grayscale-xx-light px-sm py-md flex size-full grow flex-col items-center justify-between rounded-lg border lg:max-w-[300px] lg:nth-[3n+1]:justify-self-start lg:nth-[3n+2]:justify-self-center lg:nth-[3n+3]:justify-self-end">
      <Typography
        step="1"
        as="h4"
        weight="bold"
        className="text-center"
        autoSpacing
      >
        {title}
      </Typography>
      <div className="flex flex-col items-center justify-center">
        <div className="my-xs size-[100px] lg:size-[135px]">
          <ConsolidationPie data={data} />
        </div>
        <Typography step="1" weight="bold" className="mb-3xs">
          {carbonToDisplay}
          &nbsp;
          {t(`common:unit.${carbonUnit}`)}
        </Typography>
        <div>
          <CategoryDetailPopover title={title} data={data} total={carbon} />
        </div>
      </div>
    </div>
  );
}

export default CategoryChart;
